import { useContext, useEffect } from 'react';
import { SmartContext } from '../../../library/Core/SmartContext';
import { isEmpty } from '../../../library/Core/SmartFunctions';
import useDashboard from './useDashboard';

const RecentActivitySummary = () => {
    const { state } = useContext(SmartContext);
    const { getRecentActivitySummary } = useDashboard();

    useEffect(() => {
        getRecentActivitySummary();
    }, []);

    if (isEmpty(state?.data?.dashboardData?.recentActivitySummary))
    return (
        <>
            <div>No Data Available</div>
        </>
    );

    return (
        <> 
            <hr />
            <div className="xscroll">
                <ul className="recentActivitySummaryInsight">
                    <li>
                        <div className="font-30 font-700">{state?.data?.dashboardData?.recentActivitySummary?.applications_this_week || 0}</div>
                        <div className="font-16 font-400">Applications<br /> This Week</div>
                    </li>
                    <li>
                        <div className="font-30 font-700">{state?.data?.dashboardData?.recentActivitySummary?.new_interests_this_week || 0}</div>
                        <div className="font-16 font-400">New<br /> Interests This Week</div>
                    </li>
                    <li>
                        <div className="font-30 font-700">{state?.data?.dashboardData?.recentActivitySummary?.jobs_posted_this_month || 0}</div>
                        <div className="font-16 font-400">Jobs<br /> Posted This Month</div>
                    </li>
                    <li>
                        <div className="font-30 font-700">{state?.data?.dashboardData?.recentActivitySummary?.views_this_week || 0}</div>
                        <div className="font-16 font-400">Views<br /> This Week</div>
                    </li>
                </ul>
            </div>
        </>
    );
};

export default RecentActivitySummary;
